export function AddTemplateActiveIcon({
  className = "size-6",
}: {
  className?: string;
}) {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className={className}>
      <path d="M21 15.64V8.36C21 7.18389 21 6.59583 20.7956 6.14662C20.6159 5.75148 20.329 5.43022 19.9762 5.22889C19.5751 5 19.0501 5 18 5H14H13V19H18C19.0501 19 19.5751 19 19.9762 18.7711C20.329 18.5698 20.6159 18.2485 20.7956 17.8534C21 17.4042 21 16.8161 21 15.64Z" fill="#101828" />
      <path d="M3 6.8C3 5.11984 3 4.27976 3.28611 3.63803C3.53778 3.07354 3.93935 2.6146 4.43327 2.32698C4.99479 2 5.72986 2 7.2 2H12.8C14.2701 2 15.0052 2 15.5667 2.32698C16.0607 2.6146 16.4622 3.07354 16.7139 3.63803C17 4.27976 17 5.11984 17 6.8V17.2C17 18.8802 17 19.7202 16.7139 20.362C16.4622 20.9265 16.0607 21.3854 15.5667 21.673C15.0052 22 14.2701 22 12.8 22H7.2C5.72986 22 4.99479 22 4.43327 21.673C3.93935 21.3854 3.53778 20.9265 3.28611 20.362C3 19.7202 3 18.8802 3 17.2V6.8Z" fill="#D4D5D8" />
      <path d="M10 14.6V9.60002M7.5 12.1H12.5" stroke="#101828" stroke-width="1.66667" stroke-linecap="round" stroke-linejoin="round" />
    </svg>
  );
}

export const displayName = "AddTemplateActiveIcon";
